import { ChecklistStatus } from '../../demo/ComponentStatus/ComponentStatus.types';

export const ScrollablePaneStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.unknown,
  markupSupport: ChecklistStatus.unknown,
  highContrastSupport: ChecklistStatus.pass,
  rtlSupport: ChecklistStatus.pass,
  testCoverage: ChecklistStatus.none
};